import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "technical-form" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "search" }
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = { class: "list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "avatar" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "infos" }
const _hoisted_10 = { class: "name" }
const _hoisted_11 = { class: "type" }
const _hoisted_12 = {
  key: 0,
  class: "empty"
}

import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";

import { toast } from "@/common/utils/toast";
import { svgIcon, baseInput } from "@/common/components";

import { equipmentList } from "@/common/api/rest/equipment";
import { evaluationEquipmentList } from "@/common/api/rest/evaluation";

import type { EquipmentType } from "@/common/types/equipment";


export default /*@__PURE__*/_defineComponent({
  __name: 'equipment',
  props: {
    title: {},
    accountId: {},
    evaluationId: {},
    unic: { type: Boolean },
    ids: {}
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const selecteds = ref<any[]>([]);
const listData = ref<EquipmentType[]>([]);
const inputSearch = ref<string | null>("");

function searchEvaluation() {
  if (!props.evaluationId) return;

  evaluationEquipmentList(props.evaluationId, {
    search: inputSearch.value as string,
    limit: 500,
    page: 0,
  })
    .then((response) => {
      const { success, data } = response;

      if (success) {
        listData.value = data.list;
      } else {
        toast({ message: data.message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function searchEquipments() {
  if (!props.accountId) return;

  equipmentList(props.accountId, {
    search: inputSearch.value as string,
  })
    .then((response) => {
      const { success, data } = response;

      if (success) {
        listData.value = data.list;
      } else {
        toast({ message: data.message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function search() {
  if (props.evaluationId) {
    searchEvaluation();
    return;
  }

  searchEquipments();
}

function isDisabled(data: EquipmentType) {
  if (props.ids?.includes(data.equipment_id)) {
    return true;
  }

  return false;
}

function select(data: EquipmentType) {
  if (isDisabled(data)) {
    return;
  }

  if (props.unic) {
    selecteds.value = [data];
  } else {
    if (selecteds.value.find((sl) => sl.equipment_id === data.equipment_id)) {
      selecteds.value = selecteds.value.filter(
        (sl) => sl.equipment_id !== data.equipment_id,
      );
    } else {
      selecteds.value.push({
        equipment_id: data.equipment_id,
        name: data.name,
        code: data.code,
      });
    }
  }

  emit("update-data", selecteds.value);
}

onMounted(() => {
  search();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(baseInput), {
        modelValue: inputSearch.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputSearch).value = $event)),
        background: "#fff",
        color: "#000",
        placeholder: _unref(t)('common.labels.search'),
        "onKey:enter": _cache[2] || (_cache[2] = ($event: any) => (search()))
      }, {
        sufix: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(svgIcon), {
              icon: "search",
              size: "1.75rem",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (search()))
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "placeholder"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listData.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.equipment_id,
          class: _normalizeClass(["item", {
            active: selecteds.value.find(
              (sl) => sl.equipment_id === item.equipment_id,
            ),
            disabled: isDisabled(item),
          }]),
          onClick: ($event: any) => (select(item))
        }, [
          _createElementVNode("div", _hoisted_7, [
            (item.avatar)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: item.avatar.small
                }, null, 8, _hoisted_8))
              : (_openBlock(), _createBlock(_unref(svgIcon), {
                  key: 1,
                  icon: "no-image",
                  size: "2rem"
                }))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(item.code), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(item.name), 1)
          ])
        ], 10, _hoisted_6))
      }), 128)),
      (listData.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(t)("common.texts.no_results")), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})